import React, { Component } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Tr,
  Td,
  Table,
  Thead,
  Th,
  Tbody,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  ChevronDownIcon,
  LinkIcon,
  CalendarIcon,
} from "@chakra-ui/icons";
import { v4 as uuidv4 } from "uuid";

class SortPermissions extends React.Component {
  state = {
    //portal_home
    lstPlannerAccess: [],
    lstMoodleActive: [],
    lstSdmAccess: [],
    lstFleetAccess: [],
    lstFleetTrainerAccess: [],
    lstTruckCalendarAccess: [],
    lstBikeCalendarAccess: [],
    lstTMatrixAccess: [],
    //class.advance.model
    lstHasDeletePriviledge: [],
    lstTransferAuthorized: [],
    //training.session
    lstTrainSessionHasDeletePriviledge: [],
    //account.invoice
    lstAccountInvoiceHasDeletePriviledge: [],
    selectedTitle: "Select a table",
    lstClients: [],
    searchStaff: "",
    lstAllowed: [],
    selectedLst: "",
    lstShowPermissions: [],
  };

  componentDidMount() {
    this.addMoreListeners();
  }

  async addMoreListeners() {
    this.props.chatSocket.on("lstStaff", (data) => {
      var j = JSON.parse(data);
      //console.log(j);
      var lstAdded = [];

      for (var s in j["data"]) {
        lstAdded.push({
          id: j["data"][s]["id"],
          fn: j["data"][s]["firstname"],
          ln: j["data"][s]["lastname"],
          em: j["data"][s]["email"],
          Allowed: false,
        });
      }

      this.setState({ lstClients: lstAdded });
    });

    this.props.chatSocket.on("lstAllowed", (data) => {
      var j = JSON.parse(data);
      //console.log(j);
      var lstAdded = [];

      for (var s in j["data"]) {
        lstAdded.push(j["data"][s]["id"]);
      }
      //alert(lstAdded);
      this.setState({ lstAllowed: lstAdded });
    });

    this.props.chatSocket.on("lstShowPermissions", (data) => {
      var j = JSON.parse(data);
      this.setState({ lstShowPermissions: j["data"] });
    });

    this.props.chatSocket.emit(
      "getPermissions",
      JSON.stringify({ cmd: "getStaff" })
    );
  }

  btnSelectedTable(item) {
    switch (item) {
      case "Planner":
        this.btnRequestAllowed("lstPlannerAccess");
        break;
      case "Moodle":
        this.btnRequestAllowed("lstMoodleActive");
        break;
      case "Sdm":
        this.btnRequestAllowed("lstSdmAccess");
        break;
      case "Fleet":
        this.btnRequestAllowed("lstFleetAccess");
        break;
      case "Fleet trainer":
        this.btnRequestAllowed("lstFleetTrainerAccess");
        break;
      case "Truck calendar":
        this.btnRequestAllowed("lstTruckCalendarAccess");
        break;
      case "Bike calendar":
        this.btnRequestAllowed("lstBikeCalendarAccess");
        break;
      case "TMatrix":
        this.btnRequestAllowed("lstTMatrixAccess");
        break;
      case "Delete all":
        this.btnRequestAllowed("lstHasDeletePriviledge");
        break;
      case "Transfer":
        this.btnRequestAllowed("lstTransferAuthorized");
        break;
      case "Sessions delete":
        this.btnRequestAllowed("lstTrainSessionHasDeletePriviledge");
        break;
      case "Account delete":
        this.btnRequestAllowed("lstAccountInvoiceHasDeletePriviledge");
        break;
        case "config_users":
        this.btnRequestAllowed("config_users");
        break;
        case "account_users":
        this.btnRequestAllowed("account_users");
        break;
        case "general_admin_access":
        this.btnRequestAllowed("general_admin_access");
        break;
    }

    /* "config_users",
      "account_users",
      "general_admin_access"*/

    /*"Planner",
      "Moodle",
      "Sdm",
      "Fleet",
      "Fleet trainer",
      "Truck calendar",
      "Bike calendar",
      "TMatrix",
      "Delete all",
      "Transfer",
      "Sessions delete",
      "Account delete",*/

    this.setState({ selectedTitle: item });
  }

  btnRequestAllowed(item) {
    this.props.chatSocket.emit(
      "getPermissions",
      JSON.stringify({ cmd: "allowed", lst: item })
    );
    this.setState({ selectedLst: item });
  }

  generateStaff() {
    const { lstClients, searchStaff, lstAllowed } = this.state;
    var lst = [];

    for (var i in lstClients) {
      var btnColor = "red";
      //if (lstClients[i]["Allowed"]) {
      if (lstAllowed.includes(lstClients[i]["id"])) {
        btnColor = "green";
      }

      const name = lstClients[i]["fn"] + " " + lstClients[i]["ln"];
      const em = lstClients[i]["em"];
      const staffId = lstClients[i]["id"];

      const search = name.toLowerCase() + em.toLowerCase();

      var btnHtml = (
        <Stack key={uuidv4()}>
          <Button
            onClick={() => this.btnAddPermission(staffId)}
            colorScheme={btnColor}
          >
            {name}
          </Button>
          <Text>{em}</Text>
        </Stack>
      );

      if (searchStaff == "") {
        lst.push(btnHtml);
      } else if (search.includes(searchStaff)) {
        lst.push(btnHtml);
      }
    }

    return lst;
  }

  showAllowed() {
    const { lstClients, searchStaff, lstAllowed } = this.state;
    var lst = [];

    for (var i in lstClients) {
      var btnColor = "red";
      //if (lstClients[i]["Allowed"]) {
      if (lstAllowed.includes(lstClients[i]["id"])) {
        btnColor = "green";
      }

      const name = lstClients[i]["fn"] + " " + lstClients[i]["ln"];
      const em = lstClients[i]["em"];
      const staffId = lstClients[i]["id"];

      const search = name.toLowerCase() + em.toLowerCase();

      var btnHtml = (
        <Stack key={uuidv4()}>
          <Button
            onClick={() => this.btnDeletePermission(staffId)}
            colorScheme={btnColor}
          >
            {name}
          </Button>
          <Text>{em}</Text>
        </Stack>
      );

      if (searchStaff == "" && lstAllowed.includes(lstClients[i]["id"])) {
        lst.push(btnHtml);
      } else if (
        search.includes(searchStaff) &&
        lstAllowed.includes(lstClients[i]["id"])
      ) {
        lst.push(btnHtml);
      }
    }

    return lst;
  }

  setStaffSearchChange(event) {
    //console.log(event.target.value);
    this.setState({ searchStaff: event.target.value });
  }

  btnDeletePermission(item) {
    const { lstAllowed, selectedLst } = this.state;
    if (lstAllowed.includes(item)) {
      this.props.chatSocket.emit(
        "getPermissions",
        JSON.stringify({ cmd: "delete", lst: selectedLst, del: item })
      );
    }
  }

  btnAddPermission(item) {
    const { lstAllowed, selectedLst } = this.state;
    if (!lstAllowed.includes(item)) {
      this.props.chatSocket.emit(
        "getPermissions",
        JSON.stringify({ cmd: "add", lst: selectedLst, add: item })
      );
    }
  }

  showPermissionsTables() {
    const { lstShowPermissions } = this.state;
    var lst = [];

    for (var i in lstShowPermissions) {
      var items = lstShowPermissions[i][2];
      var trs = [];
    }

    return <div className="uiq_tbl_same_bg">{lst}</div>;
  }

  render() {
    const { selectedTitle, searchStaff } = this.state;
    var lstItems = [
      "Planner",
      "Moodle",
      "Sdm",
      "Fleet",
      "Fleet trainer",
      "Truck calendar",
      "Bike calendar",
      "TMatrix",
      "Delete all",
      "Transfer",
      "Sessions delete",
      "Account delete",
      "config_users",
      "account_users",
      "general_admin_access"
    ];
    var lstTabs = lstItems.map((item) => (
      <Button
        key={uuidv4()}
        onClick={() => this.btnSelectedTable(item)}
        className="uiq_tr"
      >
        <Text>{item}</Text>
      </Button>
    ));
    // <Text>Searching: {searchStaff}</Text>
    return (
      <Stack>
        <div className="uiq_tbl_same_bg">
        <div className="scrollBox h400px"><Stack>{lstTabs}</Stack></div>
          
          <Stack w="60%">
            <Center>
              <Text>{selectedTitle}</Text>
            </Center>
            <Input
              placeholder="Search staff"
              onChange={(e) => this.setStaffSearchChange(e)}
              value={searchStaff}
            />

            <div className="uiq_tbl_same_bg">
              <div className="scrollBox h400px">
                <Stack w="300px">
                  <Text
                    bg="green"
                    color="white"
                    fontSize="20px"
                    w="100%"
                    textAlign="center"
                    p={2}
                    rounded="md"
                  >
                    Allowed
                  </Text>
                  {this.showAllowed()}
                </Stack>
              </div>

              <div className="scrollBox h400px">
                <Stack w="300px">
                  <Center>
                    <Text
                      bg="green"
                      color="white"
                      fontSize="20px"
                      w="100%"
                      textAlign="center"
                      p={2}
                      rounded="md"
                    >
                      Staff
                    </Text>
                  </Center>
                  {this.generateStaff()}
                </Stack>
              </div>
            </div>
          </Stack>
        </div>
      </Stack>
    );
  }
}

export default SortPermissions;
